<template>
  <div>
  	<div class="filter-inline-panel cle">
      <el-form :inline="true" size="mini" :model="filters" class="filter-panel fl">
        <el-form-item :label="$t('journal.type')" prop="type">
          <el-select v-model="filters.type" class="w100" :placeholder="$t('index.pleaseInput')">
            <el-option :label="lang=='cn'?item.name_cn:item.name" :value="item.code" v-for="(item,index) in TYPE" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="init">{{$t('index.query')}}</el-button>
          <el-button type="" size="mini" @click="reset">{{$t('index.reset')}}</el-button>
        </el-form-item>
      </el-form>
      <div class="list-opinion fr">
        <!-- <el-button type="primary" size="mini" @click="add('')">{{$t('index.add')}}</el-button> -->
      </div>
    </div>
    <el-table :data="list" border size="mini">
      <el-table-column prop="course_id" align="center" label="ID">
      	<template slot-scope="scope">{{scope.row.type=='course'?scope.row.course_id:scope.row.camp_id}}</template>
      </el-table-column>
      <el-table-column :prop="lang=='cn'?'course_name_cn':'course_name'" align="center" :label="$t('journal.name')">
      	<template slot-scope="scope">{{lang=='cn'?scope.row.course_name_cn:scope.row.course_name}} <span v-if="scope.row.week_sort">({{week_sort_f(scope.row)}})</span></template>
      </el-table-column>
      <el-table-column prop="type" align="center" :label="$t('journal.type')"></el-table-column>
      <el-table-column prop="user_name" align="center" :label="$t('journal.user_name')"></el-table-column>
      <el-table-column prop="email" align="center" :label="$t('journal.admin_email')"></el-table-column>
      <el-table-column prop="child_name" align="center" :label="$t('journal.child_name')"></el-table-column>
      <el-table-column prop="create_time" align="center" :label="$t('journal.create_time')">
        <template slot-scope="scope">{{getTime_us(scope.row.create_time,'mmddyyyy')}}</template>
      </el-table-column>
      <el-table-column prop="action" align="center" :label="$t('index.operation')"></el-table-column>
		<el-table-column prop="remarks" align="center" :label="$t('student_list.remarks')"></el-table-column>
    </el-table>
    <div class="page-pagination">
      <el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pager-count="5"></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
	data() {
		return {
			TYPE:[],
			list: [],
			filters:{
				type:'',
			},
			pages: {
				page: 1,
				count: 0,
				perpage: 20,
			},
		}
	},
	// 初始事件
	mounted: function () {
		this.config();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: "TYPE"
			};
			this_.$post(url, datas).then((res) => {
				this_.TYPE = res.TYPE;
				this_.init();
			})
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "adminStudentRecord";
			var datas = {
				page:this_.pages.page,
				num: this_.pages.perpage,
			};
			if (this_.filters.type) {
				datas['type']=this_.filters.type==1?'course':'camp';
			}
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		reset(){
			this.filters.type='';
			this.handleCurrentChange(1);
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		},
		week_sort_f(data){
			var this_ = this;
			var cn_array=['第一周','第二周','第三周','第四周','第五周','第六周','第七周','第八周','第九周','第十周'];
			var en_array=['First week','The second week','The third week','Fourth week','Week five','Week six','Week Seven','Week Eight','Week Nine','Week Ten'];
			if (data.type=="camp") {
				var fanhuizhi=en_array[data.week_sort];
				if (this_.lang=='cn') {
					fanhuizhi=cn_array[data.week_sort];
				}
				return fanhuizhi;
			}else{
				return '';
			}
			console.log(data);
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.transaction_id {
	color: #ff0000;
}
</style>



// WEBPACK FOOTER //
// src/views/journal/index.vue